import React from 'react'

import { useNestedProjectDropShares } from '../../hooks'

import { DroppableArea } from './NestedProjectShareDrop.styles'
import { OnDraggedOverTooltip } from '../../../shares/components/DocumentItem/DocumentItem.styles'

interface NestedProjectShareDropProps {
  projectIdentifier: string
  workspaceIdentifier: string
  children: React.ReactNode
  disabledDrag: boolean
}

const NestedProjectShareDrop: React.FCC<NestedProjectShareDropProps> = ({
  projectIdentifier,
  workspaceIdentifier,
  children,
  disabledDrag = false,
}) => {
  const {
    isDraggedOver = false,
    isDraggedOverItself = false,
    isDroppableAreaEnabled,
    ...dragAndDropEvents
  } = useNestedProjectDropShares({
    projectIdentifier,
    workspaceId: workspaceIdentifier,
    disabled: disabledDrag,
  })

  const isDroppable =
    isDroppableAreaEnabled && isDraggedOver && !isDraggedOverItself

  return (
    <>
      {isDroppable && (
        <OnDraggedOverTooltip>Add to folder</OnDraggedOverTooltip>
      )}
      <DroppableArea
        $isDraggedOver={isDroppable}
        {...(disabledDrag ? {} : dragAndDropEvents)}
      >
        {children}
      </DroppableArea>
    </>
  )
}

export default NestedProjectShareDrop
